"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmploymentType = exports.EmploymentType = void 0;
/** @TranslateToPython @TranslateToRust */
var EmploymentType;
(function (EmploymentType) {
    EmploymentType["employed"] = "employed";
    EmploymentType["selfEmployed"] = "selfEmployed";
    EmploymentType["retired"] = "retired";
    EmploymentType["other"] = "other";
})(EmploymentType || (exports.EmploymentType = EmploymentType = {}));
const isEmploymentType = (value) => value !== null && Object.values(EmploymentType).includes(value);
exports.isEmploymentType = isEmploymentType;
